import { environment } from "src/environments/environment";
import { errorHandler } from "src/app/util/errorHandler";
import { Router } from "@angular/router";
import { authData } from "src/app/util/auth";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ApiService } from "src/app/http/api.service";
import { OrderDTO, OrderHistoryDTO } from "src/app/http/api-interface";

@Component({
  selector: "app-purchase-history",
  templateUrl: "./purchase-history.component.html",
})
export class PurchaseHistoryComponent implements OnInit, OnDestroy {
  constructor(
    public apiService: ApiService,
    private httpClient: HttpClient, private router: Router) {
    }

  downloader: any = null;

  payload: any = {};
  notification = {};

  fakeLoader = false;
  skeletonLoader = true;
  loading = true;
  dialog = false;
  orderHistory: OrderHistoryDTO[] = [];

  async ngOnInit(): Promise<void> {
    this.orderHistory = await this.apiService.getOrderHistory();
    this.loading = false;
    this.skeletonLoader = false;
  }
  ngOnDestroy(): void {
    this.apiService.clearNotification();
  }

  getEncodedSession(session: string): string {
    return encodeURIComponent(session);
  }

  getDate(date: string): string {
    return new Date(date.split('T')[0]).toDateString();
  }

  getStatusClass(orderHistory: OrderHistoryDTO) : string {
    if (orderHistory.PendingFee <= 0) {
      return "bg-success";
    }
    else if (orderHistory.PaidAmount == 0) {
      return "bg-danger";
    }
    else {
      return "bg-warning";
    }
  }

  async printReciepts(collectionID: string): Promise<void> {
    if (this.loading) return;

    this.loading = true;
    this.downloader = {
      loading: true,
    };

    let res = await this.apiService.printReciept("", "0", collectionID);
    if (res.Length) {
      this.downloader = {
        loading: false,
        name: res.Name,
        url: `data:application/octet-stream;base64,${res.Data}`,
      };
    } 
    else {
      this.downloader = null;
    }
    this.loading = false;
  }
}
